import React from 'react';
// BluePrint JS
import classNames from 'classnames';
// constants
import { prefix } from '../../constants';
export const Badge = ({ className = '', count }) => {
    return React.createElement("div", { className: classNames(className, `${prefix}-badge`) }, count);
};
//# sourceMappingURL=Badge.js.map